
export const parseProducts = (arr) => {
  let products = []
  let productsIds = []
  arr.forEach((x) => {
    const index = productsIds.indexOf(x.product_id);
    if(index === -1) {
      productsIds.push(x.product_id);
      products.push({
        ...x,
        quantity: 1
      });
    } else {
      products[index].quantity++;
    }
  });
  return products;
};
